import { useState } from "react";
import "../LandingPage.css";

export default function PrivacyPolicyModal() {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // Expose the openModal function globally so footer can access it
  if (typeof window !== "undefined") {
    window.openPrivacyModal = openModal;
  }

  return (
    <>
      {isOpen && (
        <div className="privacy-modal-overlay" onClick={closeModal}>
          <div
            className="privacy-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="privacy-modal-header">
              <h2>Privacy Policy</h2>
              <button className="privacy-modal-close" onClick={closeModal}>
                ×
              </button>
            </div>
            <div className="privacy-modal-body">
              <div className="container">
                <section className="terms-title pt-4">
                  <div>
                    <img
                      src="/assets/images/Logo.png"
                      style={{
                        display: "block",
                        margin: "0 auto",
                        width: "16%",
                      }}
                      alt="Little Logo"
                    />
                    {/* <h1 className="text-uppercase">Privacy Policy</h1> */}
                  </div>
                </section>

                {/* <p className="text-secondary fw-bold">
                  {" "}
                  <small> Last updated : March 24, 2024 </small>{" "}
                </p> */}

                <p>
                  {" "}
                  <b className="text-uppercase">Little Limited</b> ("Little",
                  "us", "our" or "we") is committed to protecting your privacy.
                  Our privacy policy, which applies to all users of our{" "}
                  <a href="https://littleinfinity.in/">
                    <u>Website</u>
                  </a>
                  , the Little mobile device application ("App") and any and all
                  services provided by Little through the{" "}
                  <a href="https://littleinfinity.in/">
                    <u>Website</u>
                  </a>{" "}
                  and/or App (the "Service"), is designed to explain the
                  information we collect and how we use it to provide our
                  services and give users a better experience ("Privacy
                  policy"). This Privacy policy is part of, and incorporated
                  into, the Terms of Use. By agreeing to the terms of this
                  Privacy Policy, you consent to our collection, storage, use
                  and disclosure of your personal information and other
                  information as described in this Privacy Policy.
                </p>

                <p>
                  {" "}
                  <b className="text-uppercase">
                    {" "}
                    Please read the Privacy Policy carefully before using our
                    LITTLE DRIVER and LITTLE RIDER App.
                  </b>{" "}
                  Your access to and use of the Service is conditioned on your
                  acceptance of and compliance with these Terms. These Terms
                  apply to all visitors, users and others who access or use the
                  Service. By accessing or using the Service you agree to be
                  bound by these Terms. If you disagree with any part of the
                  terms then you may not access the Service.
                </p>

                <ol>
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Identification information data we process
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  We do not store, collect or process any sensitive data such as
                  personal data revealing racial or ethnic origin, political
                  opinions, religious or philosophical beliefs; trade-union
                  membership; genetic data, biometric data processed solely to
                  identify a human being; health-related data; data concerning a
                  person's sex life or sexual orientation.
                </p>
                <p>
                  We may collect both "Personal Information" and "Anonymous
                  Information" about you when you use our Service. Personal
                  information is information that can be used to contact or
                  identify you, such as your full name, email address, phone
                  number, Geolocation of the passenger, the time and the
                  destination of a journey, Geolocation of drivers and driving
                  routes, payment method, billing information, profile picture,
                  information about the vehicle (the registration number, model,
                  year of manufacture and color of the vehicle), driver's
                  license data as well as information that is linked to such
                  information. "Anonymous Information" is information that
                  cannot be used to contact or identify you and is not linked to
                  information that can be used to do so. It includes passively
                  collected information about your activities on the Service,
                  such as usage data, to the extent that information is not
                  linked to your Personal Information.
                </p>
                <p>
                  You can access and browse certain portions of our Service
                  without disclosing your Personal Information, although, like
                  most Services, we passively collect certain information from
                  your devices, such as your IP address, browser information,
                  unique device identifier ("UDID") and/or your mobile operating
                  system. Please note that you can choose not to provide us with
                  certain information, but this will limit the features of the
                  Service you can access and use. In order to utilize the
                  Service, you must register with Little through the App.
                </p>

                <ol>
                  <ol>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Voluntary submitted information
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  We collect information that you provide to us during your use
                  of our Service, such as:
                </p>
                <p>
                  Personal Information that you enter when registering for the
                  Service, including your full name, email address, phone
                  number, payment method, billing information, profile picture,
                  information about the vehicle (the registration number, model,
                  year of manufacture and color of the vehicle), driver's
                  license data.
                </p>
                <p>
                  Communications with us or with other Riders of drivers of
                  vehicles using the Service ("Drivers").
                </p>
                <p>
                  Information you provide in your profile preferences, to
                  customer support services or that you post on any forums or
                  message boards in the App.
                </p>

                <ol>
                  <ol start="2">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Information collected through use of the Service
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                      <ol>
                        <li>
                          <p>
                            <span style={{ textDecoration: "none" }}>
                              <span style={{ fontStyle: "normal" }}>
                                <span style={{ fontWeight: "normal" }}>
                                  <span style={{ background: "#ffffff" }}>
                                    Location data: If you access the Service
                                    through a mobile device, we may access,
                                    collect, monitor and/or remotely store
                                    "location data," which may include the GPS
                                    coordinates of your trip (including pick-up
                                    and drop-off data) or similar information
                                    regarding the location of your mobile
                                    device.
                                  </span>
                                </span>
                              </span>
                            </span>
                          </p>
                        </li>
                        <li>
                          <p>
                            <span style={{ textDecoration: "none" }}>
                              <span style={{ fontStyle: "normal" }}>
                                <span style={{ fontWeight: "normal" }}>
                                  <span style={{ background: "#ffffff" }}>
                                    Transacting data: We collect information
                                    created during your various interactions
                                    with the Service, including the date and
                                    time or a ride booked through the Service
                                    ("Ride"), distance of Ride and amount
                                    charged.
                                  </span>
                                </span>
                              </span>
                            </span>
                          </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </ol>

                <ol>
                  <ol start="3">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Information collected via technology
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  If you are using our Website with a device other than a mobile
                  we collect information from you, including your hardware
                  model, browser type, operating system, Internet Protocol (IP)
                  and domain name. If you are using a mobile device, Little may
                  also receive your UDID, or another unique identifier, and
                  mobile operating system. We may correlate this information
                  with other Personal information we have about you. We may also
                  use cookies and URL information to gather information
                  regarding the date and time you used the Service and the
                  information for which you searched and accessed. "Cookies" are
                  small pieces of information that a website sends to your
                  device while you are viewing the website. We may use both
                  session Cookies (which expire once you close your web browser)
                  and persistent Cookies (which stay on your device until you
                  delete them) to provide you with a more personal and
                  interactive experience. Persistent Cookies can be removed by
                  following general web browser help file directions.
                </p>

                <ol>
                  <ol start="4">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Anonymous Information
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  Aggregated Anonymous Information is the combination of your
                  Anonymous Information with the Anonymous Information of other
                  Riders ("Aggregated Anonymous Information"). Aggregated
                  Anonymous Information does not allow you to be identified or
                  contacted. We may share such Aggregated Anonymous Information
                  with third parties, and, depending on the circumstances, we
                  may or may not charge third parties for such information, or
                  limit the third parties' use of the same.
                </p>
                <p>
                  We may use Anonymous Information for the following purposes:
                </p>
                <p>
                  Improve the Website, App and Service and customize your
                  experience, such as by providing targeted useful features and
                  promotions based on the type of services you seek.
                </p>
                <p>
                  Aggregate the information collected via Cookies and similar
                  technologies to use in statistical analysis to help us truck
                  trends, evaluate the effectiveness of our ads and analyze
                  patterns.
                </p>

                <ol>
                  <ol start="5">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Information provided by others
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  We collect information that Riders and Drivers provide about
                  one another, including via ratings and postings on forums or
                  message boards in the App.
                </p>

                <ol>
                  <ol start="6">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Children
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  You must be 18 years of age to become a Rider. Our Services
                  are not directed at or intended for anyone under 18 years of
                  age. We do not knowingly collect nor solicit Personal
                  Information from individuals under 18 years of age and no one
                  under age 18 may provide any Personal Information to Little.
                  If we later obtain actual knowledge that a Rider is under 18
                  years of age, we will take steps to remove that individual's
                  Personal Information from our systems and delete the account.
                  If you are the parent or guardian of a child whom you believe
                  has disclosed Personal Information to us, please contact us at{" "}
                  <a href="mailto:info.india@little.global">
                    <u>info.india@little.global</u>
                  </a>{" "}
                  so that we may be delete and remove such information from our
                  systems.
                </p>

                <ol start="2">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              PERSONAL DATA COLLECTED
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                    <p>Little collects personal data but limited to : </p>
                    <ul>
                      <li>Customer Name </li>
                      <li>Phone Number </li>
                      <li>Email Address </li>
                      <li>Identification Document Number </li>
                      <li>Location Data </li>
                    </ul>
                  </li>

                  <p className="pt-3">
                    The singular intent underlying the gathering of such data is
                    exclusively for internal utilization within the confines of
                    the platform, with an adamant commitment to non-disclosure
                    to any external entities.
                  </p>
                </ol>

                <ol start="3">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              How We Use Your Personal Information
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  We may use your Personal Information for the following
                  purposes:
                </p>
                <ol>
                  <ol>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Register and administer your account.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Provide and maintain the Service.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Facilitate communications between Riders and
                                Drivers.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Offer customer support and diagnose technical
                                and service problems.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Send communications and administrative emails
                                about the Service and reply to your inquiries.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Provide you with promotional and advertising
                                materials, which may be based on your prior
                                activity.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Personalize and tailor the features, performance
                                and support of the Website, App and Service.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Send you promotional/marketing information,
                                newsletters, offers or other information from us
                                or on behalf of our sponsors or partners.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Offer you participation in special events,
                                programs, surveys and market research.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Provide you with opportunities and functionality
                                that we think would be of particular interest to
                                you.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Improve existing and develop new products and
                                services.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Improve the quality and safety of the Website,
                                App and Service and perform internal operations.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Analyze, benchmark and conduct research on Rider
                                and Driver data and interaction with the
                                Service.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Perform accounting, auditing and other corporate
                                procedures.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Prevent and identify fraud and other unlawful
                                activity.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Comply with and enforce applicable legal
                                requirements, relevant industry standards and
                                our policies or as requested by regulators,
                                government entities, and official inquiries.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        The requisite access to location serves a dual purpose:
                        <ul>
                          <li>
                            {" "}
                            To efficiently assign driver requests in close
                            proximity to their current location{" "}
                          </li>
                          <li>
                            {" "}
                            to ensure accurate computation of trip distances,
                            thereby preventing instances of underbilling{" "}
                          </li>
                        </ul>
                      </p>
                    </li>
                  </ol>
                </ol>

                <ol start="4" className="pt-2">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              How We Share and Disclose Information
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  We know how important it is to keep your information
                  confidential. We will not rent, sell or share your Personal
                  Information with third parties except as specifically approved
                  by you at the time of disclosure or under the circumstances
                  described below.
                </p>
                <ol>
                  <ol>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                If you do not want us to use or disclose
                                Personal Information collected about you in the
                                ways identified in this Privacy Policy, you may
                                choose not to
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                      <ol>
                        <li>
                          <p>
                            <span style={{ textDecoration: "none" }}>
                              <span style={{ fontStyle: "normal" }}>
                                <span style={{ fontWeight: "normal" }}>
                                  <span style={{ background: "#ffffff" }}>
                                    Provide your Personal Information at any
                                    time or
                                  </span>
                                </span>
                              </span>
                            </span>
                          </p>
                        </li>
                        <li>
                          <p>
                            <span style={{ textDecoration: "none" }}>
                              <span style={{ fontStyle: "normal" }}>
                                <span style={{ fontWeight: "normal" }}>
                                  <span style={{ background: "#ffffff" }}>
                                    Download the App and become Rider.
                                  </span>
                                </span>
                              </span>
                            </span>
                          </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </ol>
                <p>
                  In addition to using the information collected by us for the
                  purposes described above, we may also share your information
                  as described below. By becoming a Rider, you agree to allow us
                  to share the Personal Information you provide to us in the
                  ways described in our Privacy Policy.
                </p>

                <ol>
                  <ol start="2">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Riders and Drivers
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  We share certain information about Riders (e.g., name, rating,
                  pick-up and drop-off locations) with Drivers to enable the
                  scheduling and provision of Rides.
                </p>

                <ol>
                  <ol start="3">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Business transactions
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  We may share all or some of your Personal Information with any
                  of our subsidiaries, joint ventures, or other companies under
                  common control, in which case we will require them to honor
                  this Privacy Policy. Additionally, in the event we undergo a
                  business transition such as a merger, acquisition by another
                  company, or sale of all or a portion of our assets, your
                  Personal Information may be among the assets transferred. You
                  acknowledge that such transfers may occur and are permitted by
                  this Privacy Policy, and that any entity that acquires us, is
                  merged with us or that acquires our assets may continue to
                  process your Personal Information as set forth in this Privacy
                  Policy.
                </p>

                <ol>
                  <ol start="4">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Service Providers
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  We also share Personal Information with vendors, consultants
                  and data processors who perform services on behalf of Little,
                  including without limitation, companies that provide email
                  services and host the Website, App and Service. Little has
                  selected companies who maintain high standards with respect to
                  privacy and agree to use the Personal Information only to
                  perform specific services on behalf of Little and in
                  accordance with the terms and conditions of this Privacy
                  Policy.
                </p>

                <ol>
                  <ol start="5">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Compliance with Laws, Law Enforcement and Safety
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  We may disclose information we have collected about you if
                  required to do so by law or if we, in our sole discretion,
                  believe that disclosure is reasonable to comply with the law,
                  requests or orders from law enforcement, or any legal process
                  (whether or not such disclosure is required by applicable
                  law), or to protect or defend Little or a third party's,
                  rights or property. We may also reserve the right to disclose
                  information we've collected about you for purpose of
                  protecting the health and safety of our Riders and Drivers,
                  such as in the case of risk of harm or violence against any
                  person.
                </p>

                <ol>
                  <ol start="6">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Governing Law
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  These Terms shall be governed and construed in accordance with
                  the laws of the domicile, with regard to its conflict of law
                  provisions.
                </p>
                <p>
                  Our failure to enforce any right or provision of these Terms
                  will not be considered a waiver of those rights. If any
                  provision of these Privacy Policy is held to be invalid or
                  unenforceable by a court, the remaining provisions will remain
                  in effect. These Privacy Policy constitute the entire
                  agreement between us regarding our Service and supersede and
                  replace any prior agreements we might have between us
                  regarding the Service.
                </p>

                <ol start="5">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Notifications and Marketing
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  By becoming a Rider, you consent to receive certain push
                  notifications, notifications via SMS or email from us. You may
                  modify or opt out of receiving messages sent for marketing
                  purposes, or certain other communications by sending an e-mail
                  to{" "}
                  <a href="mailto:info.india@little.global">
                    <u>info.india@little.global</u>
                  </a>
                  . Please note that despite any indicated marketing
                  preferences, we may send you administrative emails regarding
                  the Website, App or Service, including, for example, notices
                  of updates to our Privacy Policy.
                </p>

                <ol>
                  <ol>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Third Party Websites
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  Little may provide links to other websites or content that may
                  be of interest to you. However, we are not responsible for the
                  privacy practices employed by those websites or content
                  providers, nor are we responsible for the information they
                  contain. This Privacy Policy applies solely to information
                  collected by us through the Website, App and Service; thus,
                  when you use a link to go from our Website or App to another
                  third-party website, this Privacy Policy is no longer in
                  effect. We encourage you to read and consider the privacy
                  policies of these other websites before using them.
                </p>

                <ol>
                  <ol start="2">
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <strong>
                              <span style={{ background: "#ffffff" }}>
                                Direct marketing
                              </span>
                            </strong>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>
                <p>
                  We will only use your e-mail address and/ or phone number to
                  send direct marketing messages if you have given us permission
                  to do so via the{" "}
                  <a href="https://littleinfinity.in/">
                    <u>https://littleinfinity.in/</u>
                  </a>{" "}
                  website or via the Little App. We may personalize direct
                  marketing messages using the information how you use Little
                  Services (frequency of use, journeys, payments).
                </p>

                <p>
                  If you no longer wish to receive direct marketing messages,
                  please click the "Unsubscribe" link in the footer of our
                  e-mail or in profile section of the Little App
                </p>

                <ol start="6">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Access and correction
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  You can access and update your personal data via the Little
                  App.
                </p>

                <ol start="7">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Disclaimer
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  Your use of the Service is at your sole risk. The Service is
                  provided on an "AS IS" and "AS AVAILABLE" basis. The Service
                  is provided without warranties of any kind, whether express or
                  implied, including, but not limited to, implied warranties of
                  merchantability, fitness for a particular purpose,
                  non-infringement or course of performance.
                </p>
                <p>
                  Little Limited, its subsidiaries, affiliates, and its
                  licensors do not warrant that:
                </p>
                <ol>
                  <ol>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                the Service will function uninterrupted, secure
                                or available at any particular time or location;
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                any errors or defects will be corrected; c) the
                                Service is free of viruses or other harmful
                                components; or
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                the results of using the Service will meet your
                                requirements.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>

                <ol start="8">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Retention
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  Your personal data will be stored as long as you have an
                  active user (Driver/Rider) account. If your account is closed,
                  personal data will be deleted (according to the policies set
                  out in this section) from the databases, unless such data is
                  required to be retained for accounting, dispute resolution or
                  fraud prevention purposes.
                </p>
                <ol>
                  <ol>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Financial data regarding transportation services
                                provided to passengers will be stored for 3
                                years after the last journey.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Data required for accounting purposes will be
                                stored for 7 years [after the last journey].
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                In the event that there are suspicions of a
                                criminal offence, fraud or false information
                                having been provided, the data will be stored
                                for 10 years.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                In case of payment disputes, data will be
                                retained until the claim is satisfied or the
                                expiry date of such claims.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Journey history data will be stored for 3 years,
                                after which the data will be anonymized.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                Please note that the deinstallation of Little
                                App in your device does not cause the deletion
                                of your personal data.
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <p>
                        <span style={{ textDecoration: "none" }}>
                          <span style={{ fontStyle: "normal" }}>
                            <span style={{ fontWeight: "normal" }}>
                              <span style={{ background: "#ffffff" }}>
                                If the Little App has not been used for 3 years,
                                we will notify you and ask you to confirm
                                whether account is still active. If no reply is
                                received, the account will be closed and
                                personal data will be deleted unless such data
                                is required to be stored for accounting, dispute
                                resolution or fraud prevention purposes.&nbsp;
                              </span>
                            </span>
                          </span>
                        </span>
                      </p>
                    </li>
                  </ol>
                </ol>

                <ol start="9">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Deletion
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  You should also bear in mind that any request to delete your
                  personal data is possible only if we delete your account. As a
                  result of that you will not be able to use Little App via an
                  account which has been deleted.
                </p>

                <p>
                  We respond to any request for to delete personal data
                  submitted by e-mail within a month and will specify the period
                  of data deletion.
                </p>

                <ol start="10">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Portability
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  We will respond to any request for transfer of personal data
                  submitted by e-mail within a month and specify when the data
                  transfer will take place. After we have verified the user in
                  question, we will provide you with your personal data, which
                  includes: contact information, last 3 years' journey history
                  and payment information.
                </p>

                <ol start="11">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Security
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  We are very concerned with safeguarding your information. We
                  employ all reasonable administrative, physical and electronic
                  measures designed to protect your information from
                  unauthorized access. We will make any legally required
                  disclosures of any breach of the security, confidentiality, or
                  integrity of your unencrypted electronically stored "personal
                  data" (as defined in applicable state statutes on security
                  breach notification) to you via email, text or conspicuous
                  posting on the Website in the most expedient time possible and
                  without unreasonable delay, insofar as it is consistent with
                  (i) the legitimate needs of law enforcement or (ii) any
                  measures necessary to determine the scope of the breach and
                  restore the reasonable integrity of the data system. Although
                  guaranteed security does not exist either on or off the
                  Internet, we make commercially reasonable efforts to make the
                  collection and security of such information consistent with
                  this Privacy Policy and all applicable laws and regulations
                </p>

                <ol start="12">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Cross-Border Data Transfer
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  We may transfer personal data we have collected from you to a
                  third-party data processor located outside your country.
                  Please be aware that such countries may not have the same
                  level of data protection as your country, however our
                  collection, storage and use of your personal data will
                  continue to be governed by this Privacy Policy.
                </p>

                <ol start="13">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Changes to Our Privacy Policy
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  We reserve the right to change, modify, add or remove portions
                  of this Privacy Policy at any time, and any changes will
                  become effective immediately upon being posted unless we
                  advise you otherwise. However, we will not use your Personal
                  Information in a way that is materially different from the
                  uses described in this Privacy Policy without giving you an
                  opportunity to opt out. If we make significant changes, we
                  will notify you in advance of the changes through the Website
                  and/or App or through other means, such as email.
                </p>
                <p>
                  Your continued use of the Service after this Privacy Policy
                  has been amended shall be deemed to be your continued
                  acceptance of the terms and conditions of the Privacy Policy,
                  as amended. We encourage you to bookmark this webpage and
                  review this Privacy Policy regularly.
                </p>

                <ol start="14">
                  <li>
                    <p className="text-uppercase">
                      <span style={{ textDecoration: "none" }}>
                        <span style={{ fontStyle: "normal" }}>
                          <strong>
                            <span style={{ background: "#ffffff" }}>
                              Contact Us
                            </span>
                          </strong>
                        </span>
                      </span>
                    </p>
                  </li>
                </ol>
                <p>
                  If you have any questions regarding our Privacy Policy, you
                  can contact us via email at{" "}
                  <a href="mailto:info.india@little.global">
                    <u>info.india@little.global</u>
                  </a>
                  . We have 30 calendar days to respond to you.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .privacy-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }

        .privacy-modal-content {
          background-color: white;
          border-radius: 8px;
          max-width: 800px;
          width: 100%;
          max-height: 90vh;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .privacy-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid #e5e5e5;
          background-color: #f8f9fa;
        }

        .privacy-modal-header h2 {
          margin: 0;
          color: #333;
          font-size: 1.5rem;
        }

        .privacy-modal-close {
          background: none;
          border: none;
          font-size: 32px;
          cursor: pointer;
          color: #666;
          padding: 0;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .privacy-modal-close:hover {
          color: #333;
        }

        .privacy-modal-body {
          flex: 1;
          overflow-y: auto;
          padding: 20px;
        }

        @media (max-width: 768px) {
          .privacy-modal-content {
            max-height: 95vh;
          }

          .privacy-modal-header h2 {
            font-size: 1.3rem;
          }
        }
      `}</style>
    </>
  );
}
